import VillaDesignSection from './VillaDesignSection';

export default VillaDesignSection;
